import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "mEmpty",
  props: {
    content: {
      typeof: String,
      default: "It's empty here."
    },
    isBtn: {
      typeof: Boolean,
      default: false
    },
    btnText: {
      typeof: String,
      default: "Confirm"
    }
  },
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  methods: {
    onBtn() {
      this.$emit("confirm");
    }
  }
};